type ToastType = 'success' | 'error' | 'warning' | 'info';

export class Toast {
    private header: string;
    private text: string;
    private type: ToastType;

    init(header: string, text: string, type: ToastType = 'success') {
        this.header = header;
        this.text = text;
        this.type = type;
        this.show();
    }

    private exists() {
        return document.getElementById(btoa(`toast${this.textContent}`)) !== null;
    }

    private show() {
        if(this.exists()) {
            return;
        }
        const toast = document.createElement('div');
        toast.id = btoa(`toast${this.textContent}`);
        toast.classList.add('toast');
        toast.classList.add(this.type);
        toast.innerHTML = this.template;
        document.body.appendChild(toast);
        const close = toast.querySelector('.toast-close');
        setTimeout(() => {
            toast.classList.add("active");
        }, 100);
        setTimeout(() => {
            this.hide(toast);
        }, 5000);
        close?.addEventListener('click', () => {
            this.hide(toast);
        });
    }

    private hide(toast: HTMLElement) {
        toast.classList.remove("active");
        setTimeout(() => {
            toast.remove();
        }, 500)
    }

    private get headerText() {
        return this.header;
    }

    private get textContent() {
        return this.text;
    }

    private get icon(): string {
        // exclaim - &#33;
        // check - &#10003;
        switch(this.type) {
            case 'success': return '&#10003;';
            case 'error': return '&#10008;';
            case 'warning': return '&#9888;';
            case 'info': return '&#9432;';
        }
    }

    private get template() {
        return `
            <div class="toast-content">
                <i class="uil uil-check toast-check">${this.icon}</i>
                <div class="message">
                    <span class="message-text text-1">${this.headerText}</span>
                    <span class="message-text text-2">${this.textContent}</span>
                </div>
            </div>
            <i class="uil uil-multiply toast-close">&#x2715;</i>
            <div class="progress"></div>
        `;
    }


}
